import type { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = HttpBadStatusCodeError | UnknownError;

export type QueryKey = [EQueryKeys.Announcements__V1_GetBusinessPossibleAppointments];
export const getQueryKey = (): QueryKey => [EQueryKeys.Announcements__V1_GetBusinessPossibleAppointments];
